export const licenseAllStatus = {
  AdditionalDocumentRequest: "additional documents request",
  AdditionalDetailsRequest: "additional details request",
  RequestStatutoryFee: "request statutory fee",
  StatutoryFeeRequested: "statutory fee requested",
  StatutoryFeeApproved: "statutory fee approved",
  StatutoryFeePaid: "statutory fee paid",
};
